(function () {
	'use strict';

	angular.module('DcProjectSubscriptionModule').config(stateConfig);

	stateConfig.$inject = ['$stateProvider'];

	function stateConfig($stateProvider) {
		$stateProvider.state('project-subscription-parent', {
			url: '/project-subscription',
			parent: 'target-project',
			abstract: true,
		});

		$stateProvider.state('project-subscriptions', {
			url: '/list',
			parent: 'project-subscription-parent',
			data: {
				admin: false,
				access: '*',
				title: 'Project Subscription',
				redirectTo: 'projects',
			},
			resolve: {
				checkPermission: [
					'$q',
					'$state',
					'$stateParams',
					'toaster',
					'gettextCatalog',
					'AjsPermissionRequester',
					'NO_ACCESS',
					function (
						$q,
						$state,
						$stateParams,
						toaster,
						gettextCatalog,
						AjsPermissionRequester,
						NO_ACCESS
					) {
						return AjsPermissionRequester.haveListPermissionForElement(
							'DATALINK'
						).then((canCreate) => {
							if (canCreate) {
								return $q.resolve(true);
							}
							toaster.pop(
								'warning',
								gettextCatalog.getString('Accès non autorisé')
							);
							return $q.reject({
								code: NO_ACCESS,
							});
						});
					},
				],
			},
			views: {
				'@project-subscription-parent': {
					template: `<app-subscription-list-standalone
												ng-prop-project_label="$ctrl.projectLabel" ></app-subscription-list-standalone>`,
					controller: [
						'AppSelectorService',
						function (AppSelectorService) {
							const $ctrl = this;
							init();
							function init() {
								$ctrl.projectLabel =
									AppSelectorService.getSelectedProjectLabel();
							}
						},
					],
					controllerAs: '$ctrl',
				},
			},
		});

		$stateProvider.state('project-subscription-new', {
			url: '/create',
			parent: 'project-subscription-parent',
			data: {
				admin: false,
				access: '*',
				title: 'Nouveau DataLink',
				redirectTo: 'project-subscriptions',
			},
			resolve: {
				checkPermission: [
					'$q',
					'$state',
					'$stateParams',
					'toaster',
					'gettextCatalog',
					'AjsPermissionRequester',
					'NO_ACCESS',
					function (
						$q,
						$state,
						$stateParams,
						toaster,
						gettextCatalog,
						AjsPermissionRequester,
						NO_ACCESS
					) {
						return AjsPermissionRequester.haveCreatePermissionForElement(
							'DATALINK'
						).then((canCreate) => {
							if (canCreate) {
								return $q.resolve(true);
							}
							toaster.pop(
								'warning',
								gettextCatalog.getString('Accès non autorisé')
							);
							return $q.reject({
								code: NO_ACCESS,
							});
						});
					},
				],
			},
			views: {
				'@project-subscription-parent': {
					controller: [
						'$timeout',
						'NgProjectSubscription',
						function ($timeout, NgProjectSubscription) {
							$timeout(function () {
								NgProjectSubscription.openCreateNewProjectSubscriptionModal();
							}, 16);
						},
					],
				},
			},
		});

		$stateProvider.state('project-subscription-view', {
			url: '/:subscriptionId/view',
			parent: 'project-subscription-parent',
			data: {
				admin: false,
				access: '*',
				title: 'DataLink',
				redirectTo: 'project-subscriptions',
			},
			resolve: {
				checkPermission: [
					'$q',
					'$state',
					'$stateParams',
					'toaster',
					'gettextCatalog',
					'AjsPermissionRequester',
					'NO_ACCESS',
					function (
						$q,
						$state,
						$stateParams,
						toaster,
						gettextCatalog,
						AjsPermissionRequester,
						NO_ACCESS
					) {
						const subscriptionId = +$stateParams.subscriptionId;

						return AjsPermissionRequester.haveViewPermissionFor(
							'DATALINK',
							subscriptionId
						).then((hasPermission) => {
							if (hasPermission) {
								return $q.resolve(true);
							}
							toaster.pop(
								'warning',
								gettextCatalog.getString('Accès non autorisé')
							);
							return $q.reject({
								code: NO_ACCESS,
							});
						});
					},
				],
				checkExists: [
					'$q',
					'$state',
					'$stateParams',
					'gettextCatalog',
					'AjsElementCheckerRequester',
					'NO_ACCESS',
					'checkPermission',
					function (
						$q,
						$state,
						$stateParams,
						gettextCatalog,
						AjsElementCheckerRequester,
						NO_ACCESS,
						checkPermission
					) {
						const subscriptionId = +$stateParams.subscriptionId;

						return AjsElementCheckerRequester.elementExists(
							'DATALINK',
							subscriptionId
						).then((exists) => {
							if (exists) {
								return $q.resolve(true);
							}
							return $q.reject({
								code: NO_ACCESS,
							});
						});
					},
				],
				targetSubscription: [
					'$stateParams',
					'NgProjectSubscription',
					function ($stateParams, NgProjectSubscription) {
						NgProjectSubscription.getInViewSubscriptionId().then((val) => {
							if (+$stateParams.subscriptionId !== val) {
								NgProjectSubscription.selectSubscription(
									+$stateParams.subscriptionId
								);
							}
						});
					},
				],
			},
			views: {
				'@project-subscription-parent': {
					template: `<app-subscription-view ng-prop-subscription_id="$ctrl.subscriptionId"
																					ng-prop-project_label="$ctrl.projectLabel"></app-subscription-view>`,
					controller: [
						'$stateParams',
						'AppSelectorService',
						function ($stateParams, AppSelectorService) {
							const $ctrl = this;
							init();
							function init() {
								const subscriptionId = parseInt(
									$stateParams['subscriptionId'],
									10
								);
								$ctrl.subscriptionId = !Number.isNaN(subscriptionId)
									? subscriptionId
									: null;
								$ctrl.projectLabel =
									AppSelectorService.getSelectedProjectLabel();
							}
						},
					],
					controllerAs: '$ctrl',
				},
			},
		});

		$stateProvider.state('subscription-simulator', {
			url: '/:subscriptionId/simulator',
			parent: 'project-subscription-parent',
			data: {
				admin: false,
				access: '*',
				title: 'Subscription simulator',
				redirectTo: 'project-subscriptions',
			},
			resolve: {
				checkPermission: [
					'$q',
					'$state',
					'$stateParams',
					'toaster',
					'gettextCatalog',
					'AjsPermissionRequester',
					'NO_ACCESS',
					function (
						$q,
						$state,
						$stateParams,
						toaster,
						gettextCatalog,
						AjsPermissionRequester,
						NO_ACCESS
					) {
						const subscriptionId = +$stateParams.subscriptionId;

						return AjsPermissionRequester.haveViewPermissionFor(
							'DATALINK',
							subscriptionId
						).then((canCreate) => {
							if (canCreate) {
								return $q.resolve(true);
							}
							toaster.pop(
								'warning',
								gettextCatalog.getString('Accès non autorisé')
							);
							return $q.reject({
								code: NO_ACCESS,
							});
						});
					},
				],
				checkExists: [
					'$q',
					'$state',
					'$stateParams',
					'gettextCatalog',
					'AjsElementCheckerRequester',
					'NO_ACCESS',
					'checkPermission',
					function (
						$q,
						$state,
						$stateParams,
						gettextCatalog,
						AjsElementCheckerRequester,
						NO_ACCESS,
						checkPermission
					) {
						const subscriptionId = +$stateParams.subscriptionId;

						return AjsElementCheckerRequester.elementExists(
							'DATALINK',
							subscriptionId
						).then((exists) => {
							if (exists) {
								return $q.resolve(true);
							}
							return $q.reject({
								code: NO_ACCESS,
							});
						});
					},
				],
			},
			views: {
				'@project-subscription-parent': {
					template: `<app-subscription-simulator ng-prop-subscription_id="$ctrl.subscriptionId"
																							 ng-prop-project_label="$ctrl.projectLabel"></app-subscription-simulator>`,
					controller: [
						'$stateParams',
						'AppSelectorService',
						function ($stateParams, AppSelectorService) {
							const $ctrl = this;
							init();
							function init() {
								const subscriptionId = parseInt(
									$stateParams['subscriptionId'],
									10
								);
								$ctrl.subscriptionId = !Number.isNaN(subscriptionId)
									? subscriptionId
									: null;
								$ctrl.projectLabel =
									AppSelectorService.getSelectedProjectLabel();
							}
						},
					],
					controllerAs: '$ctrl',
				},
			},
		});
	}
})();
